/* lua.js generated code 0.3.1 */

GamePlayCacheManager = xClass("GamePlayCacheManager")
let _instance = null
GamePlayCacheManager.getInstance = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    if (!_instance) {
        _instance = GamePlayCacheManager.create()
    }
    return _instance
}
GamePlayCacheManager.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    self.notUsePropStep = 0
    self.data = Persistence.readFileData(LocalDataFiles.kGamePlayCache) || table()
    if (!self.data.fourTileData) {
        let data = table()
        data.lowAction = table([1, "mergerCount", 0])
        data.highAction = table([1, "notMergercount", 0])
        self.data.fourTileData = data
        self.resetHighActionFourTile()
    }
}
GamePlayCacheManager.prototype.getFourTileData = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    return self.data.fourTileData
}
GamePlayCacheManager.prototype.flushData = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    Persistence.writeFileData(self.data, LocalDataFiles.kGamePlayCache)
}
GamePlayCacheManager.prototype.resetHighActionFourTile = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    self.data.fourTileData.highAction = table([1, "notMergercount", 0])
}
GamePlayCacheManager.prototype.addLowActionFourTileAdvice = function (level) {
    let self = this
    // body
    let data = self.data.fourTileData
    if (!data.lowAction.adviced) {
        data.lowAction.adviced = table()
    }
    let adviced = data.lowAction.adviced
    adviced[tostring(level)] = data.lowAction.mergerCount
    self.flushData()
}
GamePlayCacheManager.prototype.addFourTileMergerData = function (level, hasMerger) {
    let self = this
    // body
    if (!LevelType.isMainLevel(level)) {
        return 
    }
    let data = self.data.fourTileData
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    if (topLevel <= GamePlayConfig_FourTile_Guide_Level_Reach) {
        if (hasMerger) {
            data.lowAction.mergerCount = data.lowAction.mergerCount + 1
            self.flushData()
        }
    } else {
        if (hasMerger) {
            self.resetHighActionFourTile()
        } else {
            data.highAction.notMergercount = data.highAction.notMergercount + 1
        }
        self.flushData()
    }
}
GamePlayCacheManager.prototype.isNeedLowLevelAdviceFourTile = function (level) {
    let self = this
    // body
    let lowData = self.data.fourTileData.lowAction
    let count = lowData.mergerCount
    let pre = null
    for (let k = 1, v = GamePlayConfig_FourTile_Level_List[1]; v; k++, v = GamePlayConfig_FourTile_Level_List[k]) {
        if (level === v.level) {
            if (count < v.max) {
                if (pre && lowData.adviced && lowData.adviced[tostring(pre.level)]) {
                    if (count - lowData.adviced[tostring(pre.level)] >= 2) {
                        return false
                    }
                }
                self.addLowActionFourTileAdvice(level)
                return true
            }
        }
        pre = v
    }
    return false
}
GamePlayCacheManager.prototype.isNeedHighLevelAdviceFourTile = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    let count = self.data.fourTileData.highAction.notMergercount
    if (count === GamePlayConfig_FourTile_Guide_EndTimes_Reach) {
        return true
    } else if (count > GamePlayConfig_FourTile_Guide_EndTimes_Reach) {
        let dis = Math.ceil(GamePlayConfig_FourTile_Guide_EndTimes_Reach / 5) + 1
        if ((count - GamePlayConfig_FourTile_Guide_EndTimes_Reach) % (dis) === 0) {
            return true
        }
    }
    return false
}

GamePlayCacheManager.prototype.startLevel = function () {
    let self = this
    // body
    self.notUsePropStep = 0
}

GamePlayCacheManager.prototype.useStep = function () {
    let self = this
	// body
    self.notUsePropStep = self.notUsePropStep + 1
}

GamePlayCacheManager.prototype.useProp = function () {
    let self = this
	// body
    self.notUsePropStep = 0
}
GamePlayCacheManager.prototype.isFirstAppearPropBlock = function () {
    let self = this
    if (self.data.appearPropBlock) {
        return false
    } else {
        return true
    }
}
GamePlayCacheManager.prototype.appearPropblock = function () {
    let self = this
    self.data.appearPropBlock = true
    self.flushData()
}
GamePlayCacheManager.prototype.addSwapMergeNum = function (num) {
    let self = this
    // body
    if (num > 0) {
        self.data.swapMergeNum = self.data.swapMergeNum + num
        self.flushData()
    }
}
GamePlayCacheManager.prototype.getSwapMergeNum = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    return self.data.swapMergeNum
}